import { render, staticRenderFns } from "./GesetzlicheVertretung.vue?vue&type=template&id=1d567094"
import script from "./GesetzlicheVertretung.vue?vue&type=script&lang=js"
export * from "./GesetzlicheVertretung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports